import React, { useEffect, useState } from "react";
import s from "./MembersPage.module.css";
import commonStyles from '../../common/CommonStyles.module.css';

const MembersPage = () => {
  const [members, setMembers] = useState([]);
  const [selectedMember, setSelectedMember] = useState(null);
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('Основное');

  useEffect(() => {
    fetchMembers();
  }, []);

  const fetchMembers = async () => {
    const response = await fetch("/api/users/members");
    const data = await response.json();
    setMembers(data);
  };

  const handleOpenProfile = (member) => {
    setSelectedMember(member);
    setIsProfileModalOpen(true);
  };

  const handleExcludeMember = async () => {
    if (window.confirm("Вы уверены, что хотите исключить этого члена организации?")) {
      try {
        await fetch(`/api/users/${selectedMember.id}/exclude`, {
          method: "DELETE"
        });
        fetchMembers();
        setIsProfileModalOpen(false);
      } catch (error) {
        console.error("Ошибка при исключении:", error);
      }
    }
  };

  const CompactField = ({ label, value }) => (
    <div style={{ padding: '0.25rem 0.5rem', background: '#f8f9fa', borderRadius: 4, minHeight: 40, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      <label style={{ fontSize: '0.75rem', color: '#7f8c8d', marginBottom: 2 }}>{label}</label>
      <div style={{ fontSize: '0.875rem', color: '#2c3e50', wordBreak: 'break-word', lineHeight: 1.3 }}>{value || 'Не указано'}</div>
    </div>
  );

  return (
    <div className={commonStyles.pageContainer}>
      <div className={commonStyles.contentContainer}>
        <div className={commonStyles.content}>
          <h2 style={{ color: 'rgb(151, 1, 14)', textAlign: 'center', fontFamily: 'Ysabeau SC, sans-serif' }}>
            Члены организации
          </h2>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {members.map((member) => (
              <li key={member.id} style={{ display: 'flex', alignItems: 'center', padding: '0.75rem', margin: '0.5rem 0', background: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: 6, transition: 'background 0.2s' }}>
                <span style={{ flex: 1 }}>{member.firstName} {member.lastName}</span>
                <button onClick={() => handleOpenProfile(member)} style={{ marginLeft: 16, padding: '0.5rem 1rem', background: '#3498db', color: 'white', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: '0.875rem', transition: 'background 0.2s' }}>
                  Открыть профиль
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
      {isProfileModalOpen && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: 'white', borderRadius: 8, width: '95%', maxWidth: 640, maxHeight: '90vh', display: 'flex', flexDirection: 'column', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem', borderBottom: '1px solid #ecf0f1' }}>
              <h2 style={{ margin: 0, fontSize: '1.25rem', color: '#2c3e50' }}>Профиль пользователя</h2>
              <button style={{ background: 'none', border: 'none', fontSize: 24, cursor: 'pointer', color: '#666', lineHeight: 1, transition: 'color 0.2s' }} onClick={() => setIsProfileModalOpen(false)}>&times;</button>
            </div>
            <div style={{ borderBottom: '1px solid #ecf0f1', overflowX: 'auto' }}>
              <div style={{ display: 'flex', minWidth: 'max-content', padding: '0 0.5rem' }}>
                {['Основное', 'Контакты', 'Документы', 'Родители', 'Дополнительно'].map((tab) => (
                  <button
                    key={tab}
                    style={{
                      padding: '0.75rem 1rem',
                      border: 'none',
                      background: 'none',
                      cursor: 'pointer',
                      color: activeTab === tab ? '#2196F3' : '#7f8c8d',
                      fontSize: '0.875rem',
                      whiteSpace: 'nowrap',
                      borderBottom: activeTab === tab ? '2px solid #2196F3' : '2px solid transparent',
                      transition: 'color 0.2s',
                    }}
                    onClick={() => setActiveTab(tab)}
                  >
                    {tab}
                  </button>
                ))}
              </div>
            </div>
            <div style={{ flex: 1, padding: '1rem', overflowY: 'auto' }}>
              {activeTab === 'Основное' && (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '0.5rem', padding: '0.5rem 0' }}>
                  <CompactField label="Фамилия" value={selectedMember?.lastName} />
                  <CompactField label="Имя" value={selectedMember?.firstName} />
                  <CompactField label="Отчество" value={selectedMember?.patronymic} />
                  <CompactField label="Пол" value={selectedMember?.gender} />
                  <CompactField label="Дата рождения" value={selectedMember?.birthDate} />
                  <CompactField label="Место рождения" value={selectedMember?.birthPlace} />
                  <CompactField label="Национальность" value={selectedMember?.nationality} />
                </div>
              )}
              {activeTab === 'Контакты' && (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '0.5rem', padding: '0.5rem 0' }}>
                  <CompactField label="Телефон" value={selectedMember?.phoneNumber} />
                  <CompactField label="Email" value={selectedMember?.email} />
                  <CompactField label="Адрес" value={selectedMember?.address} />
                  <CompactField label="Соцсети" value={selectedMember?.socialMedia} />
                  <CompactField label="Адрес регистрации" value={selectedMember?.registrationAddress} />
                </div>
              )}
              {activeTab === 'Документы' && (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '0.5rem', padding: '0.5rem 0' }}>
                  <CompactField label="Серия паспорта" value={selectedMember?.passportSeries} />
                  <CompactField label="Номер паспорта" value={selectedMember?.passportNumber} />
                  <CompactField label="Кем выдан" value={selectedMember?.passportIssuedBy} />
                  <CompactField label="Дата выдачи" value={selectedMember?.passportIssueDate} />
                  <CompactField label="Образование" value={selectedMember?.education} />
                </div>
              )}
              {activeTab === 'Родители' && (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '0.5rem', padding: '0.5rem 0' }}>
                  <CompactField label="ФИО родителя" value={selectedMember?.parentFullName} />
                  <CompactField label="Телефон родителя" value={selectedMember?.parentPhone} />
                  <CompactField label="Email родителя" value={selectedMember?.parentEmail} />
                </div>
              )}
              {activeTab === 'Дополнительно' && (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '0.5rem', padding: '0.5rem 0' }}>
                  <CompactField label="Мотивация" value={selectedMember?.motivation} />
                  <CompactField label="Членство в организациях" value={selectedMember?.memberships} />
                  <CompactField label="Статус" value={selectedMember?.status} />
                  <CompactField label="Комментарий модератора" value={selectedMember?.revisionComment} />
                </div>
              )}
            </div>
            <div style={{ padding: '1rem', borderTop: '1px solid #ecf0f1', background: 'white', boxShadow: '0 -2px 8px rgba(0,0,0,0.05)' }}>
              <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
                <button style={{ padding: '0.75rem 1.5rem', background: '#e74c3c', color: 'white', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: '0.875rem', fontWeight: 500, transition: 'background 0.2s' }} onClick={handleExcludeMember}>
                  Исключить из организации
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MembersPage;